import { useNavigate } from "react-router-dom";
import { FaCalendarDay } from "react-icons/fa";
import StatusBadge from "../../components/activities/statusBadge";
import TypeBadge from "../../components/activities/typeBadge";
import RankingBadge from "../../components/activities/rankingBadge";
import VisibilityBadge from "./visibilityBadge";

export default function ActivityCard({ activity, idx = null }) {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(`/activities/${activity.id}`, { state: { from: "player-side" }})}
      className="p-3 bg-white rounded shadow hover:bg-gray-50 cursor-pointer flex flex-col gap-2"
    >
      {/* TOP: index + name */}
      <div className="flex items-start gap-1 text-left">
        {idx !== null && (
          <span className="text-gray-500 shrink-0">{idx + 1}.</span>
        )}

        <span className="text-blue-600 underline hyphens-auto font-medium">
          {activity.name}
        </span>
      </div>

      {/* DATE */}
      <div className="flex items-center gap-2 text-gray-600 text-sm mt-1">
        <FaCalendarDay size={14} />
        <span>
          {activity.startDate} → {activity.endDate}
        </span>
      </div>

      {/* BADGES ROW (left: visibility, right: others) */}
      <div className="flex justify-between items-center mt-1">
        
        {/* LEFT side = visibility */}
        <VisibilityBadge visibility={activity.visibility} />

        {/* RIGHT side = status + type + ranking */}
        <div className="flex flex-wrap gap-2 justify-end">
          <StatusBadge status={activity.status} />
          <TypeBadge type={activity.type} />
          {activity.type === "tournament" && (
            <RankingBadge ranking={activity.rankingType} />
          )}
        </div>
      </div>
    </div>
  );
}
